<template>
    <div class="ds-gdpr-overlay" :data-src="bg" ref="gdprOverlay">
        <div class="ds-gdpr-overlay__content" ref="gdprOverlayContent">
            <div class="ds-gdpr-overlay__content-inner">
                <h3 class="ds-gdpr-overlay__title">{{ header }}</h3>
                <p class="ds-gdpr-overlay__text">
                    <span v-html="message"></span>
                    <template v-if="videoUrl">
                        <span>
                            Video můžete zhlédnout přímo na webové stránce poskytovatele
                            <a :href="videoUrl" target="_blank" rel="noreferrer"><strong>zde</strong></a
                            >.
                        </span>
                    </template>
                </p>
            </div>

            <div class="ds-gdpr-overlay__actions">
                <DsButton type="primary" theme="dark" @click="consent">{{ button }}</DsButton>
                <DsButton type="secondary" :href="linkUrlCombined" is-external>{{ link }}</DsButton>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
/* eslint-disable @nx/enforce-module-boundaries */
import { ref, onMounted } from "vue";
import { useWecomaIntegration } from "@allwyn/gdpr/utils/use-wecoma-integration";
import { useWebpBackgroundImage } from "@allwyn/utils/webp-background-images";
import { WECOMA_CONSTANTS } from "@allwyn/utils/wecoma/wecoma-constants";
import { GDPR_OVERLAY_DEFAULT_CONFIG } from "./ds-gdpr-overlay-default-config";
import DsButton from "../button/ds-button.vue";

const { header, message, button, link, linkUrl, bg } = environment.gdprOverlay || GDPR_OVERLAY_DEFAULT_CONFIG;
const preferenceCenterLinkUrl = `${appSettings["Integrations:Wecoma:Domain"]}?key=${WECOMA_CONSTANTS.WecomaCode}&locale=cs-CZ&authKeys=${WECOMA_CONSTANTS.WecomaAuthKey}&source=thirdpartycontent`;
const linkUrlCombined = linkUrl || preferenceCenterLinkUrl;
const gdprOverlay = ref<HTMLElement | null>(null);
const gdprOverlayContent = ref<HTMLElement | null>(null);

const { consentToThirdParty } = useWecomaIntegration();

const consent = async () => {
    await consentToThirdParty();
};

onMounted(() => {
    gdprOverlay.value.style.minHeight = `calc(${gdprOverlay.value.scrollHeight}px + calc(var(--sp-dynamic-300, 24px) * 2))`;

    useWebpBackgroundImage(gdprOverlay.value);
});

defineProps<{
    videoUrl: string;
}>();

defineExpose({
    gdprOverlayContent,
});
</script>
